import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, Send, Check } from "lucide-react";
import { toast } from "sonner";

export const BackupEmailSettings = () => {
  const [cfg, setCfg] = useState({ email: "", last_email_at: "", last_email_error: "" });
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => { api.get("/backup/settings").then((r) => { setCfg(r.data); setEmail(r.data.email); setLoaded(true); }); }, []);

  const save = async () => {
    try {
      const r = await api.put("/backup/settings", { email: email.trim() || null });
      setCfg(r.data); toast.success(r.data.email ? "E-posta adresi kaydedildi" : "E-posta gönderimi kapatıldı");
    } catch { toast.error("Geçerli bir e-posta adresi girin"); }
  };
  const sendNow = async () => {
    setBusy(true);
    try { const r = await api.post("/backup/email-now"); setCfg(r.data); toast.success("Yedek e-postayla gönderildi"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gönderilemedi"); }
    finally { setBusy(false); }
  };

  return (
    <section className="mt-5 rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-6" data-testid="backup-email-card">
      <div className="flex items-center gap-2 mb-1">
        <Mail className="w-5 h-5 text-[#B45309]" />
        <h2 className="font-display text-xl font-bold uppercase tracking-tight">E-postayla Yedek</h2>
      </div>
      <p className="text-sm text-[#6B5B4A] mb-4">Her akşamki otomatik yedek bu adrese Excel eki olarak gönderilir. Boş bırakırsanız e-posta gönderilmez.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input type="email" placeholder="ornek@firma.com" value={email} onChange={(e) => setEmail(e.target.value)}
          disabled={!loaded} data-testid="backup-email-input" className="h-11 bg-[#EFE6D6] border-[#DCCFB8] flex-1" />
        <Button onClick={save} disabled={!loaded} data-testid="backup-email-save" className="h-11 bg-[#D97706] hover:bg-[#B45309] text-white">
          <Check className="w-4 h-4 mr-1" /> Kaydet</Button>
        <Button variant="outline" onClick={sendNow} disabled={busy || !cfg.email} data-testid="backup-email-send-now"
          className="h-11 border-[#DCCFB8] bg-transparent text-[#B45309]">
          <Send className="w-4 h-4 mr-1" /> {busy ? "Gönderiliyor..." : "Şimdi Gönder"}</Button>
      </div>
      {cfg.last_email_at && (
        <p className={`text-xs mt-3 ${cfg.last_email_error ? "text-[#B91C1C]" : "text-[#047857]"}`} data-testid="backup-email-status">
          Son gönderim: {new Date(cfg.last_email_at).toLocaleString("tr-TR")} — {cfg.last_email_error || "başarılı"}
        </p>
      )}
    </section>
  );
};
